import { storeItemAsync, getItemAsync } from "@towersystems/roam-common-native";
import { SuggestType } from "@towersystems/roam-common/lib/generated-types";
import { useState, useCallback } from "react";
import { useFullTextSearch } from "../../../../utilities/fulltext-search";
import { useSortBy } from "../../../../utilities/use-sort";
import { StockCountSearchContext } from "../../../../utilities/stock-count/context";
import { ScanMode } from "../../../../utilities/stock-count";

export interface StockCountSearchProviderProps {
  children?: React.ReactNode;
}

const SCAN_MODE_STORAGE_KEY = "__roam_stock_count_scan_mode__";
const DEFAULT_SCAN_MODE = "quick" as const;

export function StockCountSearchProvider({
  children,
}: StockCountSearchProviderProps) {
  const fullTextSearch = useFullTextSearch({
    type: SuggestType.PRODUCT,
    responseType: "complete",
    activeOnly: true,
  });

  const sortBy = useSortBy<{
    counted: undefined;
    expected: undefined;
  }>();

  const [activeTab, setActiveTab] = useState<number>(0);

  const [scanMode, setScanMode] = useState<ScanMode>(DEFAULT_SCAN_MODE);

  const [showProductView, setShowProductView] = useState(false);

  const updateScanMode = useCallback((value: ScanMode) => {
    setScanMode(value);
    saveScanMode(value).catch(console.log);
  }, []);

  async function saveScanMode(scanModeToSave: ScanMode) {
    return storeItemAsync(SCAN_MODE_STORAGE_KEY, scanModeToSave);
  }

  async function loadScanMode() {
    const loadedScanMode = await getItemAsync(SCAN_MODE_STORAGE_KEY);

    if (!loadedScanMode) return DEFAULT_SCAN_MODE;

    return loadedScanMode as ScanMode;
  }

  return (
    <StockCountSearchContext.Provider
      value={{
        activeTab,
        fullTextSearch,
        scanMode,
        showProductView,
        sortBy,
        loadScanMode,
        setShowProductView,
        setActiveTab,
        updateScanMode,
      }}
    >
      {children}
    </StockCountSearchContext.Provider>
  );
}
